import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Spin, Select, Checkbox, message, DatePicker, Tooltip } from 'antd'
import { ReactComponent as IconReport } from "../../../assets/icon/operation-report.svg"
import ChartReport from './ChartReport'
import moment from 'moment'
import { getListPartner } from '../../../services/api/3dApi'
import { getListSku } from '../../../services/api/apiSku'
import ProductionEfficiencyTable from './ProductionEfficiencyTable'
import { getReportProductionStage, getReportProductionStageCompare } from '../../../services/api/apiOrdersReport'
import ExportTableToCSV from './ExportTableToCSV'
import CombinedChart from './CombinedChart'
import '../styles/_ProductionEfficiencyPage.scss'
import { v4 as uuidV4 } from 'uuid'

const { RangePicker } = DatePicker

function ProductionEfficiencyPage() {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState(null)
    const [error, setError] = useState('')
    const [productionState, setProductionState] = useState('')
    const [printingPartner, setPrintingPartner] = useState('')
    const [sewingPartner, setSewingPartner] = useState('')
    const [sewingGroup, setSewingGroup] = useState('')
    //createdBatch Mặc định: 15 ngày trước - today
    //Cho phép chọn khoảng thời gian tối đa 6 tháng (180 ngày)
    const [createdBatch, setCreatedBatch] = useState([moment().subtract(15, 'days'), moment()])
    const [createdBatch1, setCreatedBatch1] = useState([]) //[moment().subtract(45, 'days'), moment().subtract(16, 'days')]
    const [tempRange, setTempRange] = useState([null, null])
    const [isCompare, setIsCompare] = useState(false)
    const [productType, setProductType] = useState([])
    const [listPartner, setListPartner] = useState([])
    const [listSewingPartner, setListSewingPartner] = useState([])
    const [listProductType, setListProductType] = useState([])
    const [groupData, setGroupData] = useState(3)
    const [combineType, setCombineType] = useState('percent') //count | percent

    const handleChangeSelect = (field, value) => {
        if (field === 'productionState') setProductionState(value)
        if (field === 'printingPartner') setPrintingPartner(value)
        if (field === 'sewingPartner') {
            const { groupId = '', } = (Array.isArray(listSewingPartner) ? (listSewingPartner.find(p => p.idx === value) || {}) : {})
            setSewingPartner(value)
            setSewingGroup(groupId)
        }
        if (field === 'productType') setProductType(value)
        if (field === 'groupData') setGroupData(value)
        if (field === 'combineType') setCombineType(value)
    }

    const handleChangeCheckBox = (e) => {
        setIsCompare(e.target.checked)
        if (e.target.checked === false) {
            setCreatedBatch1([])
            setCombineType('percent')
        }
    }

    const handleChangeRangeDate = (field, e) => {
        if (field === 'createdBatch') setCreatedBatch(e)
        if (field === 'createdBatch1') setCreatedBatch1(e)
    }

    const fetchPartner = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            hidden: false,
        }
        try {
            const { data, success, message: mess } = await getListPartner(payload)
            const { partners: newListPartner = [] } = data || {}
            if (!success) {
                throw new Error(mess)
            }
            const newListSewingPartner = newListPartner.filter(i => i.type_partner === 'sewing_partner')
                .flatMap(partner => {
                    if (partner.has_groups) {
                        return partner.groups.map(group => ({
                            ...partner,
                            ...group,
                            idx: uuidV4(),
                            partnerName: partner.name,
                            groupId: group._id,
                            partnerId: partner._id
                        }))
                    }

                    return { ...partner, idx: uuidV4(), partnerName: partner.name, partnerId: partner._id }
                })
            setListPartner(newListPartner)
            setListSewingPartner(newListSewingPartner)
        } catch (e) {
            message.error(e.message)
        }
    }

    const fetchListSKU = async () => {
        try {
            const payload = {
                limit: 10000,
                page: 1,
                sort: "name"
            }

            const { data: responsive } = await getListSku(payload)

            const { success, data, message } = responsive || {}

            if (!success) {
                throw new Error(message)
            }

            const { items } = data
            const listTypes = items.map(item => {
                return {
                    name: item.name,
                    value: item.sku,
                    label: item.sku,
                }
            })
            setListProductType(listTypes)
        } catch (e) {
            message.error(e.message)
        }
    }


    const fetchProductionEfficiencyReport = async () => {
        setLoading(true)
        setError('')
        setData(null)

        try {
            const payload = {
                // 'options[stage]': 'printed_time',
                'options[return_total]': 1,
                // 'options[add_time_unit_to_key]': 1,
                'options[time_unit]': 'h',
                'options[group_stage]': 1,
                'options[stage_value_only]': 1,
                'options[time_count]': 5,
            }
            if (printingPartner) payload.printing_partner = printingPartner
            if (sewingPartner) {
                const { partnerId = '', } = (Array.isArray(listSewingPartner) ? (listSewingPartner.find(p => p.idx === sewingPartner) || {}) : {})
                payload.sewing_partner = partnerId
            }
            if (sewingGroup) payload.sewing_group = sewingGroup
            if (productionState) payload[`options[stage]`] = productionState
            if (!!groupData) payload[`options[time_step]`] = groupData
            if (Array.isArray(createdBatch) && createdBatch.length === 2) {
                payload['created_at[from]'] = moment(createdBatch[0]).format('DD/MM/YYYY')
                payload['created_at[to]'] = moment(createdBatch[1]).format('DD/MM/YYYY')
            }
            if (Array.isArray(createdBatch1) && createdBatch1.length === 2 && isCompare) {
                payload['options[compare_dates][0][from]'] = moment(createdBatch1[0]).format('DD/MM/YYYY')
                payload['options[compare_dates][0][to]'] = moment(createdBatch1[1]).format('DD/MM/YYYY')
            }
            if (Array.isArray(productType) && productType.length > 0) payload.product_type = productType

            const { data: res } = isCompare ? await getReportProductionStageCompare(payload) : await getReportProductionStage(payload)

            const { data: newData, success, message: mess } = res || {}

            if (!success) {
                throw new Error(mess)
            }
            setData(newData)
        } catch (e) {
            message.error(e.message)
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchPartner()
        fetchListSKU()
    }, [])

    useEffect(() => {
        const validRangeDate = arr => Array.isArray(arr) && arr.length === 2

        const shouldFetch = productionState && (
            isCompare
                ? (validRangeDate(createdBatch) && validRangeDate(createdBatch1))
                : validRangeDate(createdBatch)
        )

        if (shouldFetch) {
            fetchProductionEfficiencyReport()
        } else {
            setData(null);
        }
    }, [productionState, printingPartner, sewingPartner, groupData, createdBatch, createdBatch1, isCompare, productType])

    const convertBins = (obj) => {
        if (!Object.keys(obj || {}).length) return { labels: [], items: [], total: 0, combinedNames: [] }
        const entries = Object.entries(obj || {}).filter(([k]) => k.startsWith('from_') || k === 'total')

        entries.sort((a, b) => {
            const getLower = (key) => {
                const m = key.match(/^from_(\d+)/)
                return m ? Number(m[1]) : Infinity
            }
            return getLower(a[0]) - getLower(b[0])
        })
        const items = entries
            .filter(([k]) => k.startsWith('from_'))
            .map(([k, v]) => {
                const mRange = k.match(/^from_(\d+)_to_(\d+)$/)
                if (mRange) return { label: `${mRange[1]} - ${mRange[2]}`, value: Number(v) }

                const mAndOver = k.match(/^from_(\d+)_and_over$/)
                if (mAndOver) return { label: `Lớn hơn ${mAndOver[1]}`, value: Number(v) }

                return { label: k, value: Number(v) }
            })

        const labels = items.map(i => i.label)
        const total = obj && obj.total ? Number(obj.total) : items.reduce((s, it) => s + it.value, 0)
        const combinedName = obj && obj.date ? `${obj.date.from || ''} - ${obj.date.to || ''}` : ''
        return { labels, items, total, combinedName, ...(obj.avg_time ? { avg_time: obj.avg_time } : {}) }
    }
    const productionStateOptions = [
        //printed_time,transferred_time,laser_cut_time,mex_time,sewing_time,sewed_time,receive_sew_time,completed_time
        { label: 'Chờ in: Tạo lô - In', value: 'printed_time' },
        { label: 'Chờ ép: In - Ép', value: 'transferred_time' },
        { label: 'Chờ cắt: Ép - Cắt', value: 'laser_cut_time' },
        { label: 'Chờ ép Mex: Cắt - Ép Mex', value: 'mex_time' },
        { label: 'Chờ giao may: Ép Mex - Chờ giao may', value: 'sewing_time' },
        { label: 'Chờ may: Giao may - May', value: 'sewed_time' },
        { label: 'Chờ nhận may: Đã may - Nhận may', value: 'receive_sew_time' },
        { label: 'Chờ QCHT: Nhận may - Hoàn Thành', value: 'completed_time' },
        //package_item_time,label_time,package_box_time
        { label: 'Chờ đóng gói: QCHT - Đóng gói', value: 'package_item_time' },
        { label: 'Chờ dán label: Đóng gói - Dán label', value: 'label_time' },
        { label: 'Chờ đóng thùng: Dán label - Đóng thùng', value: 'package_box_time' },
    ]

    const printingPartnerOptions = Array.isArray(listPartner) ? listPartner.filter(i => i.type_partner === 'print_partner')
        .map(i => ({ label: i.name, value: i._id, })) : []

    const sewingPartnerOptions = Array.isArray(listSewingPartner) && listSewingPartner.length > 0 ? listSewingPartner
        .map(i => ({ label: (!!i.has_groups ? `${i.partnerName} - ${i.name}` : i.name), value: i.idx, })) : []
    const chartData = !!isCompare && Array.isArray(data) ? data.map(i => convertBins(i)) : convertBins(data)


    const disabledDate = (current, value) => {
        const activeRange = (tempRange && (tempRange[0] || tempRange[1])) ? tempRange : (value || [null, null])
        if (!current) return false
        const todayEnd = moment().endOf('day')

        // chặn ngày trong tương lai chung
        if (current.isAfter(todayEnd, 'day')) return true

        const [start, end] = activeRange || [null, null]

        // chưa chọn gì: chỉ chặn future
        if (!start && !end) return false

        // chỉ có end (chọn start): start must be in [end - 180d, end]
        if (!start && end) {
            const minStart = end.clone().subtract(180, 'days').startOf('day');
            return current.isBefore(minStart, 'day') || current.isAfter(end, 'day');
        }

        // chỉ có start (chọn end): end must be in [start, start + 180d]
        if (start && !end) {
            const maxEnd = start.clone().add(180, 'days').endOf('day');
            return current.isBefore(start, 'day') || current.isAfter(maxEnd, 'day');
        }

        // cả start & end đã có (ví dụ value mặc định)
        if (start && end) {
            // cho phép nếu current thuộc 1 trong 2 khoảng:
            // 1) [end - 180d, end]  -> hợp lệ khi user muốn chọn start
            // 2) [start, start + 180d] -> hợp lệ khi user muốn chọn end
            const minStart = end.clone().subtract(180, 'days').startOf('day'); // lower bound để chọn start
            const maxEnd = start.clone().add(180, 'days').endOf('day');      // upper bound để chọn end

            const inStartRange = !current.isBefore(minStart, 'day') && !current.isAfter(end, 'day')
            const inEndRange = !current.isBefore(start, 'day') && !current.isAfter(maxEnd, 'day')

            // nếu không thuộc cả 2 khoảng -> disable
            return !(inStartRange || inEndRange)
        }

        return false
    }

    const onCalendarChange = (dates) => {
        setTempRange(dates)
    }

    const onChangeRange = (field, dates) => {
        if (field === 'createdBatch') setCreatedBatch(dates || [null, null])
        if (field === 'createdBatch1') setCreatedBatch1(dates || [null, null])
        setTempRange([null, null]) // reset temp
        handleChangeRangeDate(field, dates)
    }

    const getQuantityType = () => {
        if (['printed_time', 'transferred_time', 'laser_cut_time', 'mex_time', 'sewing_time', 'sewed_time', 'receive_sew_time', 'completed_time'].includes(productionState)) {
            return 'Số lượng lô'
        }

        if (['package_item_time', 'label_time', 'package_box_time'].includes(productionState)) {
            return 'Số lượng item'
        }
        return 'Số lượng'
    }

    const getLabelFilterDate = () => {
        if (['printed_time', 'transferred_time', 'laser_cut_time', 'mex_time', 'sewing_time', 'sewed_time', 'receive_sew_time', 'completed_time'].includes(productionState)) {
            return 'Thời gian tạo lô'
        }

        if (['package_item_time', 'label_time', 'package_box_time'].includes(productionState)) {
            return 'Thời gian tạo đơn'
        }
        return 'Thời gian'
    }
    

    return (
        <Row className="ProductionEfficiencyPage text-center">
            <Col md={12} className="Left">
                <div className="ForecastShipBatchPage">
                    <Card>
                        <CardHeader
                            className="d-flex align-items-center justify-content-start bg-warning text-dark header-elements-inline">
                            <h2 className="card-title d-flex align-items-center">
                                <IconReport width={30} />
                                <span className="ml-2">Hiệu suất sản xuất</span>
                                <Tooltip title='Tài liệu chi tiết'>
                                    <a href='https://confluence.mymerchize.com/pages/viewpage.action?pageId=114433953' target='_blank'>
                                        <i className='fa fa-info-circle mx-2 text-info' />
                                    </a>
                                </Tooltip>
                            </h2>
                        </CardHeader>
                        <CardBody>
                            <div className="headerBody d-flex justify-content-between align-items-start flex-wrap">
                                <div className="leftContent d-flex flex-wrap align-items-start mr-2">
                                    <div className="itemFilter d-flex flex-column align-items-start justify-content-end mr-3 mb-2">
                                        <label style={{ minHeight: 20 }}>Công đoạn sản xuất</label>
                                        <Select
                                            placeholder='Công đoạn sản xuất'
                                            value={productionState || []}
                                            options={productionStateOptions}
                                            allowClear
                                            showSearch
                                            showArrow
                                            disabled={loading}
                                            onChange={(value) => handleChangeSelect('productionState', value)}
                                            style={{ minWidth: 290 }}
                                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                        />
                                    </div>
                                    {!['package_item_time', 'label_time', 'package_box_time'].includes(productionState) &&
                                        <>
                                            <div className="itemFilter d-flex flex-column align-items-start justify-content-end mr-3 mb-2">
                                                <label style={{ minHeight: 20 }}>Partner in ép</label>
                                                <Select
                                                    placeholder='Partner in ép'
                                                    value={printingPartner || []}
                                                    options={printingPartnerOptions}
                                                    allowClear
                                                    showSearch
                                                    showArrow
                                                    disabled={loading}
                                                    onChange={(value) => handleChangeSelect('printingPartner', value)}
                                                    style={{ minWidth: 185 }}
                                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                />
                                            </div>
                                            <div className="itemFilter d-flex flex-column align-items-start justify-content-end mr-3 mb-2">
                                                <label style={{ minHeight: 20 }}>Partner may</label>
                                                <Select
                                                    placeholder='Partner may'
                                                    value={sewingPartner || []}
                                                    options={sewingPartnerOptions}
                                                    allowClear
                                                    showSearch
                                                    showArrow
                                                    disabled={loading}
                                                    onChange={(value) => handleChangeSelect('sewingPartner', value)}
                                                    style={{ minWidth: 185 }}
                                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                />
                                            </div>
                                        </>
                                    }
                                    <div className="itemFilter d-flex flex-column align-items-start justify-content-end mr-3 mb-2">
                                        <label style={{ minHeight: 20 }}>{getLabelFilterDate()}</label>
                                        <RangePicker
                                            onChange={(e) => onChangeRange('createdBatch', e)}
                                            value={createdBatch || ['', '']}
                                            format={'DD/MM/YYYY'}
                                            allowClear
                                            disabledDate={(current) => disabledDate(current, createdBatch)}
                                            disabled={loading}
                                            onCalendarChange={onCalendarChange}
                                        />
                                        {!!isCompare &&
                                            <RangePicker
                                                onChange={(e) => onChangeRange('createdBatch1', e)}
                                                className='mt-2'
                                                value={createdBatch1 || ['', '']}
                                                format={'DD/MM/YYYY'}
                                                allowClear
                                                disabledDate={(current) => disabledDate(current, createdBatch1)}
                                                disabled={loading}
                                                onCalendarChange={onCalendarChange}
                                            />
                                        }
                                    </div>
                                    <div className="itemFilter d-flex flex-column align-items-start justify-content-end mr-3 mb-2">
                                        <label style={{ minHeight: 20 }}></label>
                                        <div className="checkBox d-flex align-items-center " style={{ height: 32 }}>
                                            <Checkbox
                                                checked={isCompare}
                                                onChange={handleChangeCheckBox}
                                                disabled={loading}
                                            >
                                                So sánh
                                            </Checkbox>
                                        </div>
                                        {!!isCompare &&
                                            <Select
                                                placeholder='Kiểu so sánh'
                                                className='mt-2'
                                                value={combineType || []}
                                                options={[
                                                    { label: 'Theo tỷ lệ %', value: 'percent' },
                                                    { label: 'Số lượng lô', value: 'count' },
                                                ]
                                                }
                                                onChange={(value) => handleChangeSelect('combineType', value)}
                                                disabled={loading}
                                                filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="rightContent d-flex flex-wrap align-items-start">
                                    <div className="itemFilter d-flex flex-column align-items-start justify-content-end mr-3 mb-2">
                                        <label style={{ minHeight: 20 }}></label>
                                        <Select
                                            placeholder='Thống kê lô theo SKU'
                                            value={productType || []}
                                            mode='multiple'
                                            tokenSeparators={[',', ' ']}
                                            options={listProductType}
                                            allowClear
                                            showSearch
                                            showArrow
                                            // disabled={loading}
                                            onChange={(value) => handleChangeSelect('productType', value)}
                                            style={{ width: 300 }}
                                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                        />
                                    </div>
                                    <div className="itemFilter d-flex flex-column align-items-start justify-content-end mr-3 mb-2">
                                        <label style={{ minHeight: 20 }}></label>
                                        <Select
                                            placeholder='Group data'
                                            value={groupData || []}
                                            options={[1, 2, 3].map(i => ({ label: `${i} giờ`, value: i }))}
                                            showSearch
                                            showArrow
                                            disabled={loading}
                                            onChange={(value) => handleChangeSelect('groupData', value)}
                                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                        />
                                    </div>
                                    <div className="actionExport d-flex flex-column align-items-start justify-content-end mb-2">
                                        <label style={{ minHeight: 20 }}></label>
                                        <ExportTableToCSV
                                            tableId="ExportTable"
                                            filename={`${isCompare ? 'compare' : ''}production-efficiency-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`}
                                            className="ant-btn mr-2"
                                            buttonText="Export"
                                            delimiter=","  // hoặc ';' nếu muốn
                                            includeHeaders={true}
                                            disabledBtn={loading}
                                        />
                                    </div>
                                </div>
                            </div>
                            {!productionState &&
                                <div style={{ textAlign: 'start' }}>
                                    <h5 className="text-danger">Cần lựa chọn công đoạn sản xuất bạn muốn thống kê</h5>
                                </div>
                            }
                            {(isCompare ?
                                ((!Array.isArray(createdBatch) || createdBatch.length !== 2) || (!Array.isArray(createdBatch1) || createdBatch1.length !== 2)) :
                                ((!Array.isArray(createdBatch) || createdBatch.length !== 2))
                            ) &&
                                <div style={{ textAlign: 'start' }}>
                                    <h5 className="text-danger">Cần lựa chọn khoảng thời gian tạo lô bạn muốn thống kê</h5>
                                </div>
                            }
                            <Spin spinning={loading} tip='Loading...'>
                                <div className='ReportPageContainer my-3'>
                                    {isCompare && Array.isArray(data) ?
                                        <CombinedChart series={chartData} combineType={combineType} /> :
                                        <ChartReport data={chartData} isCompare={isCompare} getQuantityType={getQuantityType} />
                                    }
                                    {!!productionState && !!data &&
                                        <ProductionEfficiencyTable
                                            data={data}
                                            convertBins={convertBins}
                                            isCompare={isCompare}
                                            combineType={combineType}
                                            getQuantityType={getQuantityType}
                                            productionState={productionState}
                                        />
                                    }
                                </div>
                                {!!error &&
                                    <p className="ml-2 pt-1 error text-danger">{error}</p>
                                }
                            </Spin>
                        </CardBody>
                    </Card>
                </div>
            </Col>
        </Row>
    )
}

export default ProductionEfficiencyPage